import { render, staticRenderFns } from "./AnnotationsPane.vue?vue&type=template&id=3d726e55&scoped=true&"
import script from "./AnnotationsPane.vue?vue&type=script&lang=js&"
export * from "./AnnotationsPane.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsPane.vue?vue&type=style&index=0&id=3d726e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d726e55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDivider,VIcon,VSpacer,VToolbar})
